/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticket_Fe_Pre_Tracking_MessageInputs */

const en_ticket_fe_pre_tracking_message = /** @type {(inputs: Ticket_Fe_Pre_Tracking_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your live position will be shared with the customer once you tap Travel Start below.`)
};

const ja_ticket_fe_pre_tracking_message = /** @type {(inputs: Ticket_Fe_Pre_Tracking_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下の「移動開始」をタップすると、現在地がお客様と共有されます。`)
};

const fr_ticket_fe_pre_tracking_message = /** @type {(inputs: Ticket_Fe_Pre_Tracking_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre position en direct sera partagée avec le client dès que vous appuierez sur « Démarrer le trajet » ci-dessous.`)
};

const de_ticket_fe_pre_tracking_message = /** @type {(inputs: Ticket_Fe_Pre_Tracking_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ihre Live-Position wird mit dem Kunden geteilt, sobald Sie unten auf „Anfahrt starten“ tippen.`)
};

/**
* | output |
* | --- |
* | "Your live position will be shared with the customer once you tap Travel Start below." |
*
* @param {Ticket_Fe_Pre_Tracking_MessageInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_fe_pre_tracking_message = /** @type {((inputs?: Ticket_Fe_Pre_Tracking_MessageInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_Fe_Pre_Tracking_MessageInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_fe_pre_tracking_message(inputs)
	if (locale === "ja") return ja_ticket_fe_pre_tracking_message(inputs)
	if (locale === "fr") return fr_ticket_fe_pre_tracking_message(inputs)
	return de_ticket_fe_pre_tracking_message(inputs)
});